import React from 'react';
import OnboardingLoadingPattern from './OnboardingLoadingPattern';

const SETUP_MESSAGES = [
  'Creating your workspace...',
  'Connecting to payment services...',
  'Preparing your fundraising tools...',
  'Almost ready...',
];

/**
 * Full-screen loading UI while the org is being created (M2 onboarding).
 *
 * Polished version:
 * - Stationary sage mark without a background
 * - Indeterminate width-oscillating bar (honest about unknown duration)
 * - Pulsing skeleton lines (no awkward grow-from-zero loop)
 * - Rotating subtext messages
 */
const OnboardingCreatingLoading = ({ className = '' }) => (
  <div
    className={`fixed inset-0 z-[100] flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-paper-light to-paper-muted p-4 text-center ${className}`}
  >
    <OnboardingLoadingPattern
      title="Setting up your dashboard"
      messages={SETUP_MESSAGES}
      messageIntervalMs={2500}
    />
  </div>
);

export default OnboardingCreatingLoading;
